(function () {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('EventCollectionsUpdateValidityController', EventCollectionsUpdateValidityController);

    EventCollectionsUpdateValidityController.$inject = ['EventCollections', 'parameters','$stateParams',  '$scope', 'SoopkitchenUtils', '$uibModalInstance'];

    function EventCollectionsUpdateValidityController(EventCollections, parameters, $stateParams, $scope, SoopkitchenUtils,$uibModalInstance) {
        var vm = this;

        /**** Properties ****/
        vm.waiting = false;
        vm.label = parameters.label;
        vm.validityStartTime = parameters.validityStartTime;
        vm.validityEndTime = parameters.validityEndTime;
        vm.invalidateStartDate = false;
        vm.invalidateEndDate = false;
        vm.duration = 0;
        vm.validateDates = validateDates;
        vm.clear = clear;
        vm.save = save;

        function validateDates() {
            if (SoopkitchenUtils.isValidDate(vm.validityStartTime)) {
                vm.invalidateStartDate = false;
                if (SoopkitchenUtils.isValidDate(vm.validityEndTime)) {
                    vm.invalidateEndDate = false;
                } else {
                    vm.invalidateEndDate = true;
                    return;
                }
                vm.duration = (Date.parse(vm.validityEndTime) - Date.parse(vm.validityStartTime)) / 1000;
            } else {
                vm.invalidateStartDate = true;
            }
        }

        function successDeleting() {
            $uibModalInstance.dismiss('cancel');
            location.reload();
        }

        function failureDeleting() {
           SoopkitchenUtils.invokeSweetAlert('Unknown problem with Event Collection ', vm.label, 'error', function () {
                           location.reload();
                       })
        }

        function clear() {
            EventCollections.deleteEventCollection(vm.label, successDeleting, failureDeleting);
        }

        function success () {
            SoopkitchenUtils.invokeSweetAlert('Event Collection with label ', vm.label + ' has been successfully stored ', 'success', function () {
                location.reload();
            })
        }
        function failure (response) {
            SoopkitchenUtils.prettyError(response, function () {
            })
        }
        function save() {
            EventCollections.setValidityEventCollection(vm.label,  new Date(Date.parse(vm.validityStartTime).valueOf()), new Date(Date.parse(vm.validityEndTime).valueOf()), success, failure);
        }
    }
})();
